import { initListing } from "./listing";

document.addEventListener('DOMContentLoaded', () => {
    initListing();
});